import { differenceInMinutes, format, isToday } from 'date-fns';
import { TimeWindow } from '@evermile/api';
import { DeliverySlot } from '@evermile/customer-tracking';

export function getMerchantGmtString(offset: number): string {
  return `+${offset.toString()}`;
}

export function getDateInMerchantStore(date: string | number = '', city = 'Europe/London'): Date {
  const newDate = date ? new Date(date) : new Date();
  const merchantFormattedDate = newDate.toLocaleString('en-UK', { timeZone: city }).split(',')[0].split('/');
  newDate.setMonth(+merchantFormattedDate[1] - 1, +merchantFormattedDate[0]);
  newDate.setFullYear(+merchantFormattedDate[2]);
  return newDate;
}

export function getDateTimeInMerchantStore(date: string | number = '', city = 'Europe/London'): Date {
  const newDate = date ? new Date(date) : new Date();
  const merchantFormattedDate = newDate.toLocaleString('en-UK', { timeZone: city }).split(',')[0].split('/');
  const merchantFormattedHour = newDate.toLocaleString('en-UK', { timeZone: city }).split(',')[1].split(':');
  newDate.setMonth(+merchantFormattedDate[1] - 1, +merchantFormattedDate[0]);
  newDate.setFullYear(+merchantFormattedDate[2]);
  newDate.setHours(+merchantFormattedHour[0], +merchantFormattedHour[1]);
  return newDate;
}

export function getMerchantSlotWindow(
  pickup?: TimeWindow | DeliverySlot,
  dropoff?: TimeWindow | DeliverySlot,
): { start: string; end: string } | undefined {
  if (!pickup?.start || !pickup?.end || !dropoff?.start || !dropoff?.end) return undefined;
  const pickupStartMs = +new Date(pickup.start);
  const pickupEndMs = +new Date(pickup.end);
  const dropoffStartMs = +new Date(dropoff.start);
  const dropoffEndMs = +new Date(dropoff.end);
  const overlaps = pickupStartMs < dropoffEndMs && dropoffStartMs < pickupEndMs;
  const slotStartMs = overlaps ? pickupStartMs : dropoffStartMs;
  return {
    start: new Date(slotStartMs).toISOString(),
    end: new Date(dropoffEndMs).toISOString(),
  };
}

export function getCommittedDropoffInfoText(window?: TimeWindow | DeliverySlot): string | undefined {
  if (!window?.start || !window?.end) return;
  const start = format(window.start, 'HH:mmaaa');
  const end = format(window.end, 'HH:mmaaa');
  return `Committed drop-off window: ${start}-${end}`;
}

export function getTimeWindowInfoWithDayText(window?: TimeWindow | DeliverySlot): string | undefined {
  if (!window?.start || !window?.end) return undefined;

  const startDate = new Date(window.start);

  // Format the day and date part (e.g., "Tuesday Aug 5")
  const dayDateString = format(startDate, 'EEEE MMM d');

  // Format the time parts using 12-hour clock with am/pm
  const startTime = format(startDate, 'h:mmaaa');
  const endTime = format(new Date(window.end), 'h:mmaaa');

  // Combine into the desired format
  return `${dayDateString}, ${startTime}-${endTime}`;
}
export function getTimeWindowInfoWithDayTextInMerchantTime(
  window?: TimeWindow | DeliverySlot,
  city: string = 'Europe/London',
): string | undefined {
  if (!window?.start || !window?.end) return undefined;

  // Ensure we have a default of London time
  const merchantCity = city || 'Europe/London';

  // Convert the dates to merchant's local time
  const startDateInMerchantTime = getDateTimeInMerchantStore(window.start, merchantCity);
  const endDateInMerchantTime = getDateTimeInMerchantStore(window.end, merchantCity);

  // Format the day and date part in merchant time (e.g., "Tuesday Aug 5")
  const dayDateString = format(startDateInMerchantTime, 'EEEE MMM d');

  // Format the time parts using 12-hour clock with am/pm in merchant time
  const startTime = format(startDateInMerchantTime, 'h:mmaaa');
  const endTime = format(endDateInMerchantTime, 'h:mmaaa');

  // Combine into the desired format
  return `${dayDateString}, ${startTime}-${endTime}`;
}
export function CalculateMessagesTimeString(time: number | string) {
  if (differenceInMinutes(new Date(), new Date(time)) < 1) return 'Just now';
  if (differenceInMinutes(new Date(), new Date(time)) < 60)
    return `${differenceInMinutes(new Date(), new Date(time))} min ago`;
  if (isToday(time)) return format(new Date(time), 'HH:mm');
  return format(new Date(time), 'dd/MM/yyyy');
}
